module.exports = __webpack_public_path__ + "static/img/qrcode-android.214a34a5.png";